/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIntermediaryAccreditationOrchestration
 */
export interface GetIntermediaryAccreditationOrchestration {
    /**
     * 
     * @type {number}
     * @memberof GetIntermediaryAccreditationOrchestration
     */
    proposalId: number;
    /**
     * 
     * @type {string}
     * @memberof GetIntermediaryAccreditationOrchestration
     */
    intermediaryCode: string;
}

/**
 * Check if a given object implements the GetIntermediaryAccreditationOrchestration interface.
 */
export function instanceOfGetIntermediaryAccreditationOrchestration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "intermediaryCode" in value;

    return isInstance;
}

export function GetIntermediaryAccreditationOrchestrationFromJSON(json: any): GetIntermediaryAccreditationOrchestration {
    return GetIntermediaryAccreditationOrchestrationFromJSONTyped(json, false);
}

export function GetIntermediaryAccreditationOrchestrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntermediaryAccreditationOrchestration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'intermediaryCode': json['IntermediaryCode'],
    };
}

export function GetIntermediaryAccreditationOrchestrationToJSON(value?: GetIntermediaryAccreditationOrchestration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'IntermediaryCode': value.intermediaryCode,
    };
}

